var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsNewBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1114,
    viewBox: "0 0 1440 1114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1114,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1114,
    fill: "#DD3944"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1204.25 852.809C1100.72 891.161 1044.01 836.829 1028.59 804.869C1006.45 766.517 1000.84 680.944 1155.54 645.469C1348.92 601.124 1409.44 656.255 1379.92 758.128C1350.39 860 1333.67 804.869 1204.25 852.809Z",
    fill: "#FFEEEF",
    fillOpacity: 0.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.8448 503.712C-211.786 455.122 -291.191 523.958 -312.776 564.45C-343.775 613.04 -351.629 721.456 -135.044 766.402C135.686 822.584 220.419 752.736 179.086 623.669C137.753 494.602 114.331 564.45 -66.8448 503.712Z",
    fill: "#FFEEEF",
    fillOpacity: 0.22
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.13 150.464C1259.2 114.225 1205.55 165.564 1190.96 195.764C1170.02 232.003 1164.71 312.862 1311.05 346.383C1493.98 388.285 1551.23 336.191 1523.3 239.93C1495.37 143.669 1479.55 195.764 1357.13 150.464Z",
    fill: "#FFEEEF",
    fillOpacity: 0.22
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 895.5C111.333 893.167 62.4001 897.5 68.0001 933.5C73.6001 969.5 102 961.167 115.5 952.5C133.5 931.5 67.7 899.7 20.5 952.5",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M990.92 227.149C987.538 202.102 972.317 155.394 938.497 168.942C904.677 182.49 919.179 208.29 930.658 219.497C955.167 232.317 971.365 161.053 909.307 126.927",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNewBg);
export default __webpack_public_path__ + "static/media/whats-new-bg.bfe53d355bc9ea8fb59b3d52872e7095.svg";
export { ForwardRef as ReactComponent };